export default __webpack_public_path__ + "static/media/arrow-left.8edfe59d.svg";